import { render, staticRenderFns } from "./baqiang.vue?vue&type=template&id=7fa77029&scoped=true&"
import script from "./baqiang.vue?vue&type=script&lang=ts&"
export * from "./baqiang.vue?vue&type=script&lang=ts&"
import style0 from "./baqiang.vue?vue&type=style&index=0&id=7fa77029&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa77029",
  null
  
)

export default component.exports